export default __webpack_public_path__ + "static/media/closeNotification.b736e3a3.svg";